class Responsive {
    constructor (targetElement) {
        this.targetElement = targetElement;
        this.containerSize = {};
        this.baseContainerSize = {
            width: 1280,
            height: 800
        };
        this.zoomRate;
    }

    setContainerSize() {
        this.containerSize.width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        this.containerSize.height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

        return this.getZoomRate();
    }

    getZoomRate() {
        let zoom = {};
        zoom.horizontal = this.containerSize.width / this.baseContainerSize.width;
        zoom.vertical = this.containerSize.height / this.baseContainerSize.height;

        if (zoom.horizontal > zoom.vertical) {
            this.zoomRate = zoom.vertical;
            this.setTransformCSS();
            this.targetElement.style.left = (this.containerSize.width - this.baseContainerSize.width * this.zoomRate) / 2 + 'px';
        } else {
            this.zoomRate = zoom.horizontal;
            this.setTransformCSS();
            this.targetElement.style.left = 0;
        }

        return this;
    }

    setTransformCSS() {
        let string = '';
        string += `-webkit-transform: scale(${this.zoomRate}, ${this.zoomRate});`;
        string += `-ms-transform: scale(${this.zoomRate}, ${this.zoomRate});`;
        string += `transform: scale(${this.zoomRate}, ${this.zoomRate});`;
        string += `-webkit-transform-origin: 0% 0%;`;
        string += `-ms-transform-origin: 0% 0%;`;
        string += `transform-origin: 0% 0%;`;
        this.targetElement.setAttribute('style', string);

        return this;
    }

    setResizeEvent() {
        window.addEventListener('resize', () => {
            this.setContainerSize();
        }, false);
    }

    start() {
        this.setContainerSize().setResizeEvent();
    }
}

export default Responsive;
